import { createContext } from "react";
import { useInfiniteDesignations } from "./Designation.state";

export const DesignationContext = createContext();
export const DesignationContextProvider = ({ children }) => {
    const designations = useInfiniteDesignations();

    return (
        <DesignationContext.Provider value={{ designations }}>
            { children }
        </DesignationContext.Provider>
    )
}